import { type SerializedStyles } from '@emotion/react';
import tw, { css, styled } from 'twin.macro';
import {
  StyledHeader,
  StyledHeaderImage,
  StyledHeaderContent,
} from './components/ColumnBlockHeader/ColumnBlockHeader.styles';

export const StyledContent = styled.div`
  ${tw`col-span-4`}
  ${tw`grid grid-cols-4 gap-4 md:grid-cols-8 md:gap-y-6 lg:grid-cols-12`}
  ${tw`auto-rows-min`}
`;

const containerLayouts: Record<
  Queries.kontent_item_column_block_elements_content_layout_enum,
  SerializedStyles
> = {
  vertical: css`
    ${StyledHeader} {
      ${tw`md:col-span-4 lg:col-span-6`}
      ${tw`md:grid-flow-row`}

      ${StyledHeaderImage} {
        ${tw`md:col-span-8 lg:col-span-12`}
        ${tw`md:order-first`}
      }

      ${StyledHeaderContent} {
        ${tw`md:col-span-8 lg:col-span-12`}
        ${tw`md:text-left md:items-start`}
      }
    }

    ${StyledContent} {
      ${tw`md:col-span-4 lg:col-span-5 lg:col-start-8`}
    }
  `,
  horizontal: css`
    ${StyledHeader} {
      ${tw`md:col-span-8 lg:col-span-12`}
      ${tw`md:grid-flow-col`}
    }

    ${StyledContent} {
      ${tw`md:col-span-8 lg:col-span-12`}
    }
  `,
};

export const StyledContainer = styled.div<{
  layout: Queries.kontent_item_column_block_elements_content_layout_enum;
}>`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`grid grid-cols-4 gap-4 md:grid-cols-8 md:gap-x-3 md:gap-y-6 lg:grid-cols-12 lg:gap-x-4`}
  ${tw`auto-rows-min`}

  ${({ layout }) => containerLayouts[layout]}
`;

export const StyledSection = styled.section`
  ${tw`px-2 py-7 md:px-0`}
`;
